/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Operability_DescInputs */

const en_directory_agent_readiness_operability_desc = /** @type {(inputs: Directory_Agent_Readiness_Operability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How well an agent can operate the product end-to-end without human help — auth, APIs, structured output.`)
};

const zh_directory_agent_readiness_operability_desc = /** @type {(inputs: Directory_Agent_Readiness_Operability_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 能否在无人干预下端到端操作该产品——认证、API、结构化输出。`)
};

/**
* | output |
* | --- |
* | "How well an agent can operate the product end-to-end without human help — auth, APIs, structured output." |
*
* @param {Directory_Agent_Readiness_Operability_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_operability_desc = /** @type {((inputs?: Directory_Agent_Readiness_Operability_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Operability_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_operability_desc(inputs)
	return zh_directory_agent_readiness_operability_desc(inputs)
});
export { directory_agent_readiness_operability_desc as "directory.agent_readiness.operability_desc" }